import React from 'react';

import { Component as Landmark } from '../layout/Landmark.jsx';

function Footer(props) {
    if (props.loading) {
        return <View />;
    }
    if (props.builder || !props.hasMore) {
        return null;
    }
    return (
        <div style={{ bottom: 0, position: 'absolute' }}>
            <Landmark active={props.active} useWindow={true} onEnter={props.onLoadMore} />
        </div>
    );
}

function View() {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
}

export {
    Footer,
    View
};